import { Link, useLocation } from "react-router-dom";
import "./RecipesHubPage.css";

const RecipesHubPage = ({ hubObj }) => {
  const location = useLocation();
  const { metaTitle, metaDescription, recipes } = hubObj;
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  return (
    <div className="page">
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <div className="recipes__wrapper">
        {recipes.map((recipe, idx) => {
          return (
            <Link
              to={`${langPrefix}/recipes/${recipe.link}`}
              key={idx}
              className="recipe-card"
            >
              <img
                src={recipe.image}
                alt={recipe.title}
                className="recipe-image"
              />
              <div className="recipes-texts">
                <h3 className="recipe-title mont-m">{recipe.title}</h3>
                <p className="recipe-description int-r-21">
                  {recipe.description}
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RecipesHubPage;
